
export enum ChatTypeEnum{
    Default = 0,
    CalendarEventPreMeeting = 1,
    CareerIndividualConsultantLead = 2,
    CareerInternalOrganizationLead = 3,
    StructuredProcess = 4
}

export enum ChatMessageDataType{
    Text = "text",
    Audio = "audio"
}

